import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import LoginScreen from './features/login/login';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Dashboard from './features/dashboard/dashboard';
import ProtectedRoute from './components/protected-route';
import { NotificationProvider } from './contexts/NotificationContext';

const App: React.FC = () => {
  return (
    <NotificationProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginScreen />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard/*" element={<Dashboard />} />
          </Route>
          <Route path="/" element={<LoginScreen />} />
        </Routes>
      </Router>
    </NotificationProvider>
  );
};

export default App;
